interface Env {
  baseRoute: string,
  baseUrl: string,
  env: 'dev' | 'qa' | 'prod'
}

const config: Record<string, Env> = {
  dev: {
    env: 'dev',
    baseRoute: null,
    baseUrl: 'http://localhost:8080/DashboardBackend'
  },
  qa: {
    env: 'qa',
    baseRoute: '/Dashboard',
    baseUrl: 'https://qa.rguroo.com/DashboardBackend'
  },
  prod: {
    env: 'prod',
    baseRoute: null,
    baseUrl: 'https://dashboard.rguroo.com/DashboardBackend'
  }
}

export default config[process.env.REACT_APP_ENV]